import { merchantTypes } from 'src/constants';
import { merchantService } from 'src/services';

// 取得此登入帳號所有分(總)店資訊
const getBranchesData = () => {
  return async (dispatch) => {
    try {
      const res = await merchantService.getBranchesData();
      const result = await res.json();
      dispatch({ type: merchantTypes.GET_BRANCHES_DATA, data: result });
      return result; // 回傳結果給呼叫端
    } catch (error) {
      console.log(error);
      throw error; // 讓呼叫端可以 catch
    }
  };
};

// 取得登入帳號商家資訊
const getBranchData = (merAcctId) => {
  return async (dispatch) => {
    try {
      const res = await merchantService.getBranchData(merAcctId);
      const result = await res.json();
      dispatch({ type: merchantTypes.GET_BRANCH_DATA, data: result });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

// 修改商家資訊
const editBranchData = (merAcctId, payload) => {
  return async (dispatch) => {
    try {
      const res = await merchantService.editBranchData(merAcctId, payload);
      const result = await res.json();
      dispatch({ type: merchantTypes.GET_BRANCH_DATA, data: result });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

// 取得個人帳號資訊
const getPersonalInfo = () => {
  return async (dispatch) => {
    try {
      const res = await merchantService.getPersonalInfo();
      const result = await res.json();
      dispatch({ type: merchantTypes.GET_PERSONAL_INFO, data: result });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

// 取得銷售產品類型列表
const getProdTypeList = () => {
  return async (dispatch) => {
    try {
      const res = await merchantService.getProdTypeList();
      const result = await res.json();
      dispatch({ type: merchantTypes.GET_PROD_TYPE_LIST, data: result });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const actionCreators = {
  getBranchesData,
  getBranchData,
  editBranchData,
  getPersonalInfo,
  getProdTypeList,
};